import { useCallback } from "react";
import { MESSAGE_KEY, REACT_APP_CHILD_URL, STORAGE_KEY } from "../services/constant";
import { getEndpointFitViewCustomScan, getEndpointFitViewScan, setLocalStorage } from "../utils/Utils";

// hooks/useIframeMessaging.ts
 const useIframeMessaging = ({
    isCustom,
    details,
    product,
    shopDomain,
    callbackUrl,
    name,
    setDetails,
    setupSwanCTA,
    hideIframe,
  }) => {
    const messageHandler = useCallback((event) => {
      if (event.origin !== REACT_APP_CHILD_URL) return;
      const { type, data } = event.data;
      if (type === MESSAGE_KEY.DETAILS) {
        const { email, scanId } = data;
        if (email) setLocalStorage(STORAGE_KEY.EMAIL, email);
        if (scanId && scanId !== "null") setLocalStorage(STORAGE_KEY.SCAN_ID, scanId);
        if (email || scanId) {
          hideIframe();
          setupSwanCTA();
        }
        setDetails({ ...details, email, scanID: scanId });
      } else if (data === MESSAGE_KEY.REDIRECT) {
        const endpointFunction = isCustom ? getEndpointFitViewCustomScan : getEndpointFitViewScan;
        const url = endpointFunction({
          productHandle: product?.handle,
          shopDomain,
          shopifyRedirectUrl: details?.shopifyRedirectUrl,
          callbackUrl,
          ...(isCustom && { email: details?.email, name }),
          email:details?.email
        });
        window.location.href = url;
      } else if (data === MESSAGE_KEY.CLOSE) {
        hideIframe();
      }
    }, [callbackUrl, details, hideIframe, isCustom, name, product?.handle, setDetails, setupSwanCTA, shopDomain]);
    return messageHandler;
  };
  export default useIframeMessaging